module.exports = __webpack_public_path__ + "img/1437171362.9bcef350.jpg";